<template>
  <div>
    <Button type="primary" @click="modal1 = true">
      {{ $t('configuration_management.mailbox_management.addEmailSubjectKeyword') }}
    </Button>
    <Modal v-model="modal1" :title="$t('configuration_management.mailbox_management.addEmailSubjectKeyword')" @on-ok="subjectKeywordSubmit('subjectKeywordForm')"
           @on-cancel="subjectKeywordReset('subjectKeywordForm')" :loading="loading" :mask-closable="false" :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')">
      <Form ref="subjectKeywordForm" :model="subjectKeywordForm" :label-width="160" :rules="ruleValidate">
        <!-- 公司 -->
        <FormItem :label="$t('configuration_management.mailbox_management.company')" prop="companyId" placeholder=" ">
          <Select v-model="subjectKeywordForm.companyId" style="width:300px;" placeholder="">
            <Option :value="item.id" v-for="(item,index) in companyIdList" v-bind:key="index">{{item.companyName}}</Option>
          </Select>
        </FormItem>
        <!-- 邮件主题关键词 -->
        <FormItem :label="$t('configuration_management.mailbox_management.emailSubjectKeyword')" prop="keyword">
          <Input v-model="subjectKeywordForm.keyword" placeholder="Enter something..." style="width:300px;"></Input>
        </FormItem>

      </Form>
    </Modal>
  </div>
</template>
<script>
  import TableSubjectKeyword from './TableSubjectKeyword.vue'

  var tableSubjectKeyword = TableSubjectKeyword;
  export default {
    name: 'AddSubjectKeyword',
    data() {
      return {
        subjectKeywordForm: {
          keyword: ''
        },
        modal1: false,
        loading: true,
        companyIdList:[],
        ruleValidate: {
          keyword: [
            {required: true, message: this.$t('configuration_management.mailbox_management.keywordRequired'), trigger: 'change'}
          ]
        }
      }
    },
    mounted: function(){
      this.listRegisterInformation();
    },
    methods: {
      // 公司列表
      listRegisterInformation: function () {
        this.$api.user.listRegisterInformation()
          .then(res => {
            // 获取公司列表数据
            this.companyIdList = res.data.companies;
          })
      },
      subjectKeywordSubmit: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            // 添加关键词
            this.$api.mailbox.createSubjectKeyword({
              "keyword": this.subjectKeywordForm.keyword,
              "companyId":this.subjectKeywordForm.companyId
            })
              .then(res => {
                this.data = res.data;
                setTimeout(() => {
                  tableSubjectKeyword.methods.showAll();
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t('common.addSuccess'));
                  this.modal1 = false;
                }, 1000);
              })
          } else {
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            this.$Message.error(this.$t('common.addFail'));
          }
        });
      },
      subjectKeywordReset: function (name) {
        this.$refs[name].resetFields();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/monitor_mailbox_configuration/AddSubjectKeyword.vue